var module = angular.module('octopusApp.configuration');

module.directive('userApiKeys', function(){
  return {
    restrict: 'E',
    templateUrl: 'areas/configuration/users/views/user_api_keys.html',
    controller: function($scope, busy, octopusRepository, $uibModal, octoDialog) {

      var loaded = false;
      $scope.$watch('user', function(nv, ov){
        if (loaded || !nv) {
          return;
        }
        loaded = true;
        load();
      });

      var load = function() {
        var isLoading = $scope.isLoading = busy.create();
        isLoading.promise(octopusRepository.Users.listApiKeys($scope.user).then(function(apiKeys){
          $scope.userApiKeys = apiKeys;

          $scope.newApiKey = function() {
            $uibModal.open({
              backdrop: 'static',
              keyboard: true,
              templateUrl: 'areas/configuration/users/views/create_api_key.html',
              controller: 'CreateApiKeyDialogController',
              dialogClass: 'modal',
              resolve: {
                user: function() { return $scope.user; }
              }
            }).result.then(function(result){
              if (result) {
                load();
              }
            });
          };

          $scope.revoke = function(apiKey){
            var dlg = octoDialog.confirmDelete('API key', function() {
              return octopusRepository.Users.revokeApiKey(apiKey);
            });
            dlg.then(function(result) {
              if (result) {
                load();
              }
            });
          };
        }));
      };
    }
  };
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/users/directives/user_api_keys_directive.js
// module id = 412
// module chunks = 1